document.addEventListener("DOMContentLoaded", function () {
    const generatePdfButton = document.getElementById('generate-pdf');

    document.addEventListener('click', function (event) {
      const trigger = event.target.closest('[data-we-pdp-generate-pdf]');
      if (!trigger || trigger.id === 'generate-pdf') return;
      event.preventDefault();
      generatePdfButton?.click();
    });

    if (generatePdfButton) {
      generatePdfButton.addEventListener('click', function () {
        const { jsPDF } = window.jspdf;

        const COLORS = {
          ink: [24, 24, 27],
          muted: [113, 113, 122],
          orange: [255, 89, 38],
          purple: [109, 58, 139],
          line: [228, 228, 231],
          boxBg: [250, 250, 250],
          white: [255, 255, 255]
        };

        const CONTACT = {
          phone: '+49 (0)8571 6600',
          email: 'service@skapetze.com',
          hours: 'Mo - Fr: 09:00 - 16:00 Uhr',
          cta: 'Du wünschst Sondermaße oder individuelle Anpassungen? Wir prüfen Deine Anfrage gerne für Dich.'
        };

        function textOf(el) {
          return (el?.textContent || '').replace(/\s+/g, ' ').trim();
        }

        function generateQRCode(text) {
          return new Promise((resolve, reject) => {
            try {
              const canvas = document.createElement('canvas');
              QRCode.toCanvas(canvas, text, { width: 120, margin: 1 }, function (error) {
                if (error) reject(error);
                else resolve(canvas.toDataURL('image/png'));
              });
            } catch (e) {
              reject(e);
            }
          });
        }

        function loadImageAsDataUrl(src, maxWidth = 900, { format = 'jpeg', fillWhite = true } = {}) {
          return new Promise((resolve) => {
            if (!src) {
              resolve(null);
              return;
            }

            let url = src;
            try {
              const parsed = new URL(src, window.location.origin);
              parsed.searchParams.delete('format');
              if (!parsed.searchParams.has('width')) {
                parsed.searchParams.set('width', String(maxWidth));
              }
              url = parsed.toString();
            } catch (e) {
              url = src.replace(/([?&])format=webp(&|$)/, '$1').replace(/[?&]$/, '');
            }

            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = function () {
              const meta = {
                data: url,
                width: img.naturalWidth || 1,
                height: img.naturalHeight || 1,
                format: format === 'png' ? 'PNG' : 'JPEG'
              };
              try {
                const canvas = document.createElement('canvas');
                canvas.width = img.naturalWidth;
                canvas.height = img.naturalHeight;
                const ctx = canvas.getContext('2d');
                if (fillWhite) {
                  ctx.fillStyle = '#ffffff';
                  ctx.fillRect(0, 0, canvas.width, canvas.height);
                }
                ctx.drawImage(img, 0, 0);
                meta.data =
                  format === 'png'
                    ? canvas.toDataURL('image/png')
                    : canvas.toDataURL('image/jpeg', 0.92);
              } catch (e) {
                /* keep url */
              }
              resolve(meta);
            };
            img.onerror = function () {
              resolve({ data: url, width: 1, height: 1, format: 'JPEG' });
            };
            img.src = url;
          });
        }

        function imageData(meta) {
          return meta?.data || null;
        }

        function imageAspect(meta, fallback = 1) {
          if (!meta?.width || !meta?.height) return fallback;
          return meta.width / meta.height;
        }

        /** Crisp filled star as PNG — Helvetica has no ★ glyph. */
        function makeStarDataUrl(px = 64) {
          const canvas = document.createElement('canvas');
          canvas.width = px;
          canvas.height = px;
          const ctx = canvas.getContext('2d');
          const cx = px / 2;
          const cy = px / 2;
          const outer = px * 0.48;
          const inner = px * 0.2;
          ctx.beginPath();
          for (let i = 0; i < 10; i += 1) {
            const angle = (-Math.PI / 2) + (i * Math.PI) / 5;
            const r = i % 2 === 0 ? outer : inner;
            const x = cx + r * Math.cos(angle);
            const y = cy + r * Math.sin(angle);
            if (i === 0) ctx.moveTo(x, y);
            else ctx.lineTo(x, y);
          }
          ctx.closePath();
          ctx.fillStyle = `rgb(${COLORS.orange.join(',')})`;
          ctx.fill();
          return canvas.toDataURL('image/png');
        }

        async function drawStarRow(doc, x, midY, count = 5, sizeMm = 3.2, gap = 0.55) {
          const starPng = makeStarDataUrl(96);
          for (let i = 0; i < count; i += 1) {
            const sx = x + i * (sizeMm + gap);
            await safeAddImage(doc, starPng, 'PNG', sx, midY - sizeMm / 2, sizeMm, sizeMm);
          }
          return count * (sizeMm + gap) - gap;
        }

        /** Clean outline icons matching the mockup (smartphone / envelope / clock). */
        function makeIconDataUrl(kind, px = 128) {
          const canvas = document.createElement('canvas');
          canvas.width = px;
          canvas.height = px;
          const ctx = canvas.getContext('2d');
          const stroke = 'rgb(82, 82, 91)';
          ctx.strokeStyle = stroke;
          ctx.fillStyle = stroke;
          ctx.lineWidth = Math.max(2, px * 0.07);
          ctx.lineCap = 'round';
          ctx.lineJoin = 'round';

          if (kind === 'phone') {
            // Smartphone outline (not a handset blob)
            const x = px * 0.3;
            const y = px * 0.12;
            const w = px * 0.4;
            const h = px * 0.76;
            const r = px * 0.08;
            ctx.beginPath();
            ctx.moveTo(x + r, y);
            ctx.lineTo(x + w - r, y);
            ctx.quadraticCurveTo(x + w, y, x + w, y + r);
            ctx.lineTo(x + w, y + h - r);
            ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
            ctx.lineTo(x + r, y + h);
            ctx.quadraticCurveTo(x, y + h, x, y + h - r);
            ctx.lineTo(x, y + r);
            ctx.quadraticCurveTo(x, y, x + r, y);
            ctx.closePath();
            ctx.stroke();
            // home indicator
            ctx.beginPath();
            ctx.moveTo(px * 0.4, px * 0.78);
            ctx.lineTo(px * 0.6, px * 0.78);
            ctx.stroke();
          } else if (kind === 'email') {
            const x = px * 0.14;
            const y = px * 0.26;
            const w = px * 0.72;
            const h = px * 0.48;
            const r = px * 0.04;
            ctx.beginPath();
            ctx.moveTo(x + r, y);
            ctx.lineTo(x + w - r, y);
            ctx.quadraticCurveTo(x + w, y, x + w, y + r);
            ctx.lineTo(x + w, y + h - r);
            ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
            ctx.lineTo(x + r, y + h);
            ctx.quadraticCurveTo(x, y + h, x, y + h - r);
            ctx.lineTo(x, y + r);
            ctx.quadraticCurveTo(x, y, x + r, y);
            ctx.closePath();
            ctx.stroke();
            ctx.beginPath();
            ctx.moveTo(x, y + r);
            ctx.lineTo(px / 2, y + h * 0.55);
            ctx.lineTo(x + w, y + r);
            ctx.stroke();
          } else if (kind === 'clock') {
            const cx = px / 2;
            const cy = px / 2;
            const r = px * 0.34;
            ctx.beginPath();
            ctx.arc(cx, cy, r, 0, Math.PI * 2);
            ctx.stroke();
            ctx.beginPath();
            ctx.moveTo(cx, cy);
            ctx.lineTo(cx, cy - r * 0.55);
            ctx.moveTo(cx, cy);
            ctx.lineTo(cx + r * 0.42, cy);
            ctx.stroke();
          }

          return canvas.toDataURL('image/png');
        }

        function getVendorInfo() {
          const vendorRoot = document.querySelector('.product-vendor-sku');
          if (!vendorRoot) return '';

          const vendorLink = vendorRoot.querySelector('.product-vendor__link');
          const vendorImg = vendorRoot.querySelector('.product-vendor img');
          const vendorFallback = vendorRoot.querySelector('.product-vendor__fallback');
          const vendorName = (
            vendorLink?.getAttribute('title')
            || vendorImg?.getAttribute('alt')
            || textOf(vendorFallback)
            || textOf(vendorRoot.querySelector('.product-vendor'))
          ).replace(/^Marke:\s*/i, '');

          const sku = textOf(vendorRoot.querySelector('.product-sku__value'));
          const parts = [];
          if (vendorName) parts.push(`Marke: ${vendorName}`);
          if (sku) parts.push(`SKU: ${sku}`);
          return parts.join(' | ');
        }

        function getPriceLines() {
          const priceRoot = document.querySelector('.price__default');
          if (!priceRoot) return [];

          const current = textOf(priceRoot.querySelector('.price__current'));
          const uvpLabel = textOf(priceRoot.querySelector('.price__uvp-label')) || 'UVP';
          const compare = textOf(
            priceRoot.querySelector('.price__was .price')
            || priceRoot.querySelector('.price__was')
          ).replace(/^UVP\s*/i, '');

          const lines = [];
          if (current) lines.push(current);
          if (compare) lines.push(`${uvpLabel} ${compare}`);
          return lines;
        }

        function getProductUrl() {
          try {
            const url = new URL(window.location.href);
            ['preview_theme_id', 'preview_key', '_ab', '_fd', '_sc', 'v'].forEach((key) => {
              url.searchParams.delete(key);
            });
            url.hash = '';
            return url.toString();
          } catch (e) {
            return window.location.href.split('?')[0];
          }
        }

        function getGalleryImageSrcs(limit = 3) {
          const nodes = Array.from(
            document.querySelectorAll(
              '.media-viewer__item:not([hidden]) img, .media-gallery img, .product-media img'
            )
          );
          const srcs = [];
          const seen = new Set();

          nodes.forEach((img) => {
            let src = img.currentSrc || img.src || '';
            if (!src || src.startsWith('data:')) return;
            try {
              const url = new URL(src, window.location.origin);
              url.searchParams.delete('format');
              src = url.toString();
            } catch (e) {
              /* keep src */
            }
            if (seen.has(src)) return;
            seen.add(src);
            srcs.push(src);
          });

          return srcs.slice(0, limit);
        }

        function getRatingLabel() {
          const judgeme = textOf(document.querySelector('.jdgm-prev-badge__text, .jdgm-all-reviews-rating-wrapper'));
          if (judgeme && /\d/.test(judgeme)) return judgeme;

          const line1 = textOf(document.querySelector('.pm-line1'));
          if (line1) {
            const match = line1.match(/([\d.,]+)\s*\/\s*5/);
            if (match) return `${match[1]}/5`;
          }

          const badge = textOf(document.querySelector('[href*="bewertung"], .product-rating, .rating'));
          const match = badge.match(/([\d.,]+)\s*(?:von|\/)\s*5/);
          return match ? `${match[1]}/5` : '4.96/5';
        }

        function getTrustBadgeSrcs() {
          return Array.from(document.querySelectorAll('.product-message__testimonials img'))
            .map((img) => img.currentSrc || img.src)
            .filter(Boolean)
            .slice(0, 4);
        }

        function getAdvisorImageSrc() {
          return (
            document.querySelector('.beratung-banner .beratung-image')?.currentSrc
            || document.querySelector('.beratung-banner .beratung-image')?.src
            || null
          );
        }

        function getPropertyCategories() {
          const categories = [];
          let current = null;

          document.querySelectorAll('.properties_block .properties').forEach((section) => {
            const titleEl = section.querySelector('.property-title');
            if (titleEl) {
              const name = textOf(titleEl);
              if (name) {
                current = { title: name, items: [] };
                categories.push(current);
              }
            }

            if (!current) {
              current = { title: '', items: [] };
              categories.push(current);
            }

            section.querySelectorAll('.flex-wrap').forEach((item) => {
              const label = textOf(item.querySelector('.title'));
              const value = textOf(item.querySelector('.property'));
              if (label && value) current.items.push({ label, value });
            });
          });

          return categories.filter((cat) => cat.items.length);
        }

        function formatNow() {
          const d = new Date();
          const pad = (n) => String(n).padStart(2, '0');
          return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}, ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
        }

        function ensureSpace(doc, y, needed, marginX, marginY, pageWidth) {
          if (y + needed <= doc.internal.pageSize.height - marginY - 12) {
            return y;
          }
          doc.addPage();
          drawFooter(doc, marginX, pageWidth, doc.internal.pageSize.height);
          return marginY + 8;
        }

        function drawFooter(doc, marginX, pageWidth, pageHeight) {
          const footerY = pageHeight - 8;
          doc.setDrawColor(...COLORS.line);
          doc.setLineWidth(0.3);
          doc.line(marginX, footerY - 5, pageWidth - marginX, footerY - 5);

          doc.setFont('helvetica', 'normal');
          doc.setFontSize(8);
          doc.setTextColor(...COLORS.muted);
          doc.text(`${CONTACT.email}, ${CONTACT.phone}`, marginX, footerY);

          const stamp = formatNow();
          doc.text(stamp, pageWidth / 2, footerY, { align: 'center' });

          const pageCount = doc.getNumberOfPages();
          const current = doc.internal.getCurrentPageInfo().pageNumber;
          doc.text(`${current} / ${pageCount}`, pageWidth - marginX, footerY, { align: 'right' });
        }

        function drawRoundedBox(doc, x, y, w, h, radius = 3) {
          doc.setFillColor(...COLORS.boxBg);
          doc.setDrawColor(...COLORS.line);
          doc.setLineWidth(0.45);
          doc.roundedRect(x, y, w, h, radius, radius, 'FD');
        }

        async function safeAddImage(doc, src, format, x, y, w, h) {
          if (!src) return false;
          try {
            doc.addImage(src, format, x, y, w, h);
            return true;
          } catch (e) {
            try {
              doc.addImage(src, format === 'JPEG' ? 'PNG' : 'JPEG', x, y, w, h);
              return true;
            } catch (e2) {
              return false;
            }
          }
        }

        /** Fill frame edge-to-edge so the media column reads as full width. */
        async function drawImageFill(doc, meta, x, y, boxW, boxH) {
          doc.setDrawColor(...COLORS.line);
          doc.setLineWidth(0.25);
          doc.rect(x, y, boxW, boxH, 'S');
          const data = imageData(meta);
          if (!data) return false;
          return safeAddImage(doc, data, 'JPEG', x, y, boxW, boxH);
        }

        async function generatePDF() {
          const logoSrc = 'https://cdn.shopify.com/s/files/1/0577/6519/9970/files/skapetze-logo2.png?v=1730620635';
          const titleContent = textOf(document.querySelector('.product-title'));
          const productVendorInfo = getVendorInfo();
          const priceLines = getPriceLines();
          const currentURL = getProductUrl();
          const gallerySrcs = getGalleryImageSrcs(3);
          const ratingLabel = getRatingLabel();
          const trustSrcs = getTrustBadgeSrcs();
          const advisorSrc = getAdvisorImageSrc();
          const categories = getPropertyCategories();
          const beratungTitle =
            textOf(document.querySelector('.beratung-banner .beratung-title'))
            || '30 Min. kostenlose Beratung';

          const [
            logoMeta,
            mainMeta,
            thumb1Meta,
            thumb2Meta,
            qrCodeSrc,
            advisorMeta,
            ...trustMeta
          ] = await Promise.all([
            loadImageAsDataUrl(logoSrc, 600, { format: 'png', fillWhite: false }),
            loadImageAsDataUrl(gallerySrcs[0], 1000),
            loadImageAsDataUrl(gallerySrcs[1], 400),
            loadImageAsDataUrl(gallerySrcs[2], 400),
            generateQRCode(currentURL).catch(() => null),
            loadImageAsDataUrl(advisorSrc, 200),
            ...trustSrcs.map((src) => loadImageAsDataUrl(src, 120))
          ]);

          const doc = new jsPDF({ unit: 'mm', format: 'a4', orientation: 'portrait' });
          const pageWidth = doc.internal.pageSize.width;
          const pageHeight = doc.internal.pageSize.height;
          const marginX = 12;
          const marginY = 10;
          const contentWidth = pageWidth - marginX * 2;

          // —— Header ——
          // Natural logo aspect (~4.47:1). Slightly smaller so it doesn't look "pulled up".
          const logoW = 32;
          const logoH = logoW / imageAspect(logoMeta, 4.47);
          const headerBandH = Math.max(logoH, 7.5);
          const headerMidY = marginY + headerBandH / 2;
          if (imageData(logoMeta)) {
            const logoY = headerMidY - logoH / 2;
            await safeAddImage(
              doc,
              imageData(logoMeta),
              logoMeta.format || 'PNG',
              marginX,
              logoY,
              logoW,
              logoH
            );
          }

          // Header right cluster: stars + rating | badges | phone (vertically centered)
          let cursorX = pageWidth - marginX;
          const headerTextY = headerMidY + 1.05;
          doc.setFont('helvetica', 'normal');
          doc.setFontSize(9);
          doc.setTextColor(...COLORS.ink);
          const phoneW = doc.getTextWidth(CONTACT.phone);
          cursorX -= phoneW;
          doc.text(CONTACT.phone, cursorX, headerTextY);
          cursorX -= 3.5;

          const badgeSize = 6.5;
          for (let i = trustMeta.length - 1; i >= 0; i -= 1) {
            if (!imageData(trustMeta[i])) continue;
            cursorX -= badgeSize + 1.2;
            await safeAddImage(
              doc,
              imageData(trustMeta[i]),
              'JPEG',
              cursorX,
              headerMidY - badgeSize / 2,
              badgeSize,
              badgeSize
            );
          }

          cursorX -= 3;
          doc.setFontSize(9);
          doc.setTextColor(...COLORS.ink);
          const ratingW = doc.getTextWidth(ratingLabel);
          cursorX -= ratingW;
          doc.text(ratingLabel, cursorX, headerTextY);

          cursorX -= 2.2;
          const starSize = 3.1;
          const starGap = 0.45;
          const starsWidth = 5 * (starSize + starGap) - starGap;
          cursorX -= starsWidth;
          await drawStarRow(doc, cursorX, headerMidY, 5, starSize, starGap);

          const headerLineY = marginY + headerBandH + 3;
          doc.setDrawColor(...COLORS.line);
          doc.setLineWidth(0.3);
          // Full page width (mockup), not inset to content margins
          doc.line(0, headerLineY, pageWidth, headerLineY);

          // —— Hero: gallery ~60% width; 3 side tiles share exact main-image height ——
          let y = headerLineY + 5;
          const mediaColW = contentWidth * 0.6;
          const tileGap = 2;
          // main + gap + thumb = mediaColW
          // 3*thumb + 2*gap = main  →  thumb = (main - 2*gap) / 3
          // ⇒ main = (3/4) * (mediaColW - tileGap/3)
          const mainSize = (3 / 4) * (mediaColW - tileGap / 3);
          const thumbSize = (mainSize - 2 * tileGap) / 3;
          const infoX = marginX + mediaColW + 5;
          const infoW = pageWidth - marginX - infoX;

          await drawImageFill(doc, mainMeta, marginX, y, mainSize, mainSize);

          const stackX = marginX + mainSize + tileGap;
          let stackY = y;
          for (const meta of [thumb1Meta, thumb2Meta]) {
            if (imageData(meta)) {
              await drawImageFill(doc, meta, stackX, stackY, thumbSize, thumbSize);
            } else {
              doc.setDrawColor(...COLORS.line);
              doc.rect(stackX, stackY, thumbSize, thumbSize, 'S');
            }
            stackY += thumbSize + tileGap;
          }
          // Third tile = QR — stack height equals mainSize (3*thumb + 2*gap)
          doc.setFillColor(...COLORS.white);
          doc.setDrawColor(...COLORS.line);
          doc.rect(stackX, stackY, thumbSize, thumbSize, 'FD');
          if (qrCodeSrc) {
            const qrPad = Math.max(1, thumbSize * 0.08);
            await safeAddImage(
              doc,
              qrCodeSrc,
              'PNG',
              stackX + qrPad,
              stackY + qrPad,
              thumbSize - qrPad * 2,
              thumbSize - qrPad * 2
            );
          }

          // Product info column
          let infoY = y + 2;
          // Meta: light grey, regular — not competing with title/price
          doc.setFont('helvetica', 'normal');
          doc.setFontSize(8);
          doc.setTextColor(...COLORS.muted);
          if (productVendorInfo) {
            doc.text(productVendorInfo, infoX, infoY);
            infoY += 5.5;
          }

          // Title: regular weight (mockup). Bold would look the same thickness as price.
          doc.setFont('helvetica', 'normal');
          doc.setFontSize(13);
          doc.setTextColor(...COLORS.ink);
          const titleLines = doc.splitTextToSize(titleContent || '', infoW);
          doc.text(titleLines, infoX, infoY);
          infoY += titleLines.length * 5.6 + 4;

          // Price: only bold element in this stack — clear hierarchy vs title
          if (priceLines[0]) {
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(17);
            doc.setTextColor(...COLORS.orange);
            doc.text(priceLines[0], infoX, infoY);
            infoY += 5.5;
          }
          if (priceLines[1]) {
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(8.5);
            doc.setTextColor(...COLORS.muted);
            doc.text(priceLines[1], infoX, infoY);
            infoY += 6;
          }

          // Consultation box (title + icon rows + advisor photo)
          const boxH = 28;
          const boxY = Math.max(infoY, y + mainSize - boxH);
          drawRoundedBox(doc, infoX, boxY, infoW, boxH, 3);

          const advisorSize = 16;
          const boxPad = 4;
          let boxTextX = infoX + boxPad;

          if (imageData(advisorMeta)) {
            const ax = infoX + infoW - boxPad - advisorSize;
            const ay = boxY + (boxH - advisorSize) / 2;
            await safeAddImage(doc, imageData(advisorMeta), 'JPEG', ax, ay, advisorSize, advisorSize);
          }

          let boxTY = boxY + 6.5;
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(10);
          doc.setTextColor(...COLORS.purple);
          doc.text(beratungTitle, boxTextX, boxTY);
          boxTY += 5.2;

          const iconSize = 3.2;
          const iconGap = 1.6;
          const contactRows = [
            { icon: 'phone', text: CONTACT.phone },
            { icon: 'email', text: CONTACT.email },
            { icon: 'clock', text: CONTACT.hours }
          ];
          doc.setFont('helvetica', 'normal');
          doc.setFontSize(7.5);
          doc.setTextColor(...COLORS.ink);
          for (const row of contactRows) {
            const iconPng = makeIconDataUrl(row.icon, 128);
            await safeAddImage(
              doc,
              iconPng,
              'PNG',
              boxTextX,
              boxTY - iconSize + 0.55,
              iconSize,
              iconSize
            );
            doc.text(row.text, boxTextX + iconSize + iconGap, boxTY);
            boxTY += 4.3;
          }

          y = Math.max(y + mainSize, boxY + boxH) + 4;

          // Border under the whole upper section (gallery + info) — full page width
          doc.setDrawColor(...COLORS.line);
          doc.setLineWidth(0.35);
          doc.line(0, y, pageWidth, y);
          y += 7;

          // —— Specs: two columns (light weights, hairline rows) ——
          const colGap = 8;
          const colW = (contentWidth - colGap) / 2;
          const colStarts = [marginX, marginX + colW + colGap];

          function drawCategoryColumn(cat, colX, startY) {
            let cy = startY;
            if (cat.title) {
              // Mockup: heading without underline
              doc.setFont('helvetica', 'normal');
              doc.setFontSize(10);
              doc.setTextColor(...COLORS.ink);
              doc.text(cat.title, colX, cy);
              cy += 5.5;
            }

            cat.items.forEach((item) => {
              cy = ensureSpace(doc, cy, 7, marginX, marginY, pageWidth);
              doc.setFont('helvetica', 'normal');
              doc.setFontSize(8);
              doc.setTextColor(120, 120, 128);
              const label = doc.splitTextToSize(item.label, colW * 0.55);
              doc.text(label[0], colX, cy);

              doc.setTextColor(55, 55, 60);
              const valueLines = doc.splitTextToSize(item.value, colW * 0.42);
              doc.text(valueLines[0], colX + colW, cy, { align: 'right' });

              // Line well below the text baseline so it never cuts through glyphs
              const lineY = cy + 2.2;
              doc.setDrawColor(235, 235, 237);
              doc.setLineWidth(0.2);
              doc.line(colX, lineY, colX + colW, lineY);
              cy = lineY + 3.4;
            });

            return cy;
          }

          if (categories.length) {
            // Draw up to 2 categories side by side on first row; remaining stacked in pairs.
            for (let i = 0; i < categories.length; i += 2) {
              const left = categories[i];
              const right = categories[i + 1];
              const rowStart = ensureSpace(doc, y, 28, marginX, marginY, pageWidth);
              const leftEnd = drawCategoryColumn(left, colStarts[0], rowStart);
              const rightEnd = right
                ? drawCategoryColumn(right, colStarts[1], rowStart)
                : rowStart;
              y = Math.max(leftEnd, rightEnd) + 4;
            }
          }

          // —— CTA box (larger type, like mockup) ——
          y = ensureSpace(doc, y, 24, marginX, marginY, pageWidth);
          const ctaH = 20;
          drawRoundedBox(doc, marginX, y, contentWidth, ctaH, 3);
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(13);
          doc.setTextColor(...COLORS.purple);
          const ctaLines = doc.splitTextToSize(CONTACT.cta, contentWidth - 16);
          const ctaLineH = 5.5;
          const ctaTextH = ctaLines.length * ctaLineH;
          doc.text(ctaLines, pageWidth / 2, y + (ctaH - ctaTextH) / 2 + 4.5, {
            align: 'center',
            lineHeightFactor: 1.25
          });

          // Footers on all pages
          const totalPages = doc.getNumberOfPages();
          for (let p = 1; p <= totalPages; p += 1) {
            doc.setPage(p);
            drawFooter(doc, marginX, pageWidth, pageHeight);
          }

          const fileName = `${titleContent || 'produktdatenblatt'}.pdf`.replace(/[\/:*?"<>|]/g, '');
          doc.save(fileName);
        }

        generatePDF().catch((err) => {
          console.error('PDF generation failed:', err);
        });
      });
    }
  });
